export default function HomeTitle({ children }) {
  return (
    <div className="home-title">
      <div className="yl"></div>
      <span>{children}</span>
    </div>
  );
}
